module.exports = __webpack_public_path__ + "img/pre.613d5fcf.png";